import axiosInstance from "./axiosInstance";
import Cookies from "js-cookie";

const CategoryService = {
  getAllCategory: async () => {
    try {
      const response = await axiosInstance.get(`/category/all-categories`, {
        // Public endpoint: do not attach Authorization header
        headers: { "X-Skip-Auth": true },
        skipAuth: true,
      });
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
  getCategoryById: async (id) => {
    try {
      const response = await axiosInstance.get(`/category/${id}`);
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
  createCategory: async (payload) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);

      const response = await axiosInstance.post(
        `/category/create`,
        payload, // ✅ Directly send JSON
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );

      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },

  updateCategory: async (id, payload) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.put(
        `/category/${id}`,
        payload,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },

  deleteCategory: async (id) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.delete(
        `/category/${id}`,
        token ? { headers: { Authorization: `${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      const normalized = {
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
        ...(error?.response?.data && typeof error.response.data === "object"
          ? error.response.data
          : {}),
      };
      throw normalized;
    }
  },
};

export default CategoryService;
